export enum RentalPaymentStatusEnum {
  AwaitingPayment = 'AwaitingPayment',
  Paid = 'Paid',
  Refunded = 'Refunded',
  Waived = 'Waived',
}

export const rentalPaymentStatusMap: Record<RentalPaymentStatusEnum, string> = {
  [RentalPaymentStatusEnum.AwaitingPayment]: 'Awaiting payment',
  [RentalPaymentStatusEnum.Paid]: 'Paid',
  [RentalPaymentStatusEnum.Refunded]: 'Refunded',
  [RentalPaymentStatusEnum.Waived]: 'Free',
};

export const rentalPaymentStatusColorMap: Record<RentalPaymentStatusEnum, string> = {
  [RentalPaymentStatusEnum.AwaitingPayment]: '#DCDCDC',
  [RentalPaymentStatusEnum.Paid]: '#C1FFEA',
  [RentalPaymentStatusEnum.Refunded]: '#FFA39E',
  [RentalPaymentStatusEnum.Waived]: '#D6E4FF',
};
